// Номер в БД лежит цифрами («79991234567») — показываем его человекочитаемо.
export const formatPhoneNumber = (phoneNumber: string): string => {
    const digits = phoneNumber.replace(/\D/g, "");

    if (digits.length !== 11) return phoneNumber;

    return `+${digits.slice(0, 1)} ${digits.slice(1, 4)} ${digits.slice(4, 7)} ${digits.slice(
        7,
        9
    )} ${digits.slice(9)}`;
};

// Российский формат: код страны + десять цифр.
export const PHONE_DIGITS_LENGTH = 11;

/*
* Цифры номера, пригодные к отправке. Набранный с восьмёрки «89991234567» — тот же номер,
* и заставлять переучиваться незачем.
*
* ⚠️ Замена ведущей восьмёрки живёт здесь, а не в форматтере: если её делать только при
* отрисовке, поле показывает «+7 999…», а наружу уходит «8999…» — расходятся ровно на
* вставке и автозаполнении, где второго нажатия клавиши, которое чинило бы стейт, не будет.
* Дальше номер уходит в базу как есть, и вход по нему не находит аккаунт, а регистрация
* заводит дубль (плюс филиал получает доллары и английскую локаль — они выбираются по
* первой цифре).
* */
export const phoneDigits = (value: string): string => {
    const digits = value.replace(/\D/g, "").slice(0, PHONE_DIGITS_LENGTH);

    if (digits.length === 0) return "";

    return (digits[0] === "8" ? "7" : digits[0]) + digits.slice(1);
};

export const isCompletePhone = (value: string): boolean =>
    phoneDigits(value).length === PHONE_DIGITS_LENGTH;

// Маска ввода «+7 999 123 45 67».
export const formatPhoneInput = (value: string): string => {
    const digits = phoneDigits(value);

    if (digits.length === 0) return "";

    const rest = digits.slice(1);
    const groups = [rest.slice(0, 3), rest.slice(3, 6), rest.slice(6, 8), rest.slice(8, 10)];

    return `+${digits[0]} ${groups.filter((group) => group.length > 0).join(" ")}`.trimEnd();
};
